// apps/web/src/ui/confirm.ts

let resolveRef: ((value: boolean) => void) | null = null;

export function customConfirm(message: string, confirmLabel?: string): Promise<boolean> {
    return new Promise((resolve) => {
        resolveRef = resolve;
        window.dispatchEvent(new CustomEvent("bt:confirm", { detail: { message, confirmLabel } }));
    });
}

export function resolveConfirm(value: boolean) {
    if (resolveRef) {
        resolveRef(value);
        resolveRef = null;
    }
}
